<div class="body-wrapper p-3" [formGroup]="alertvarservice.consolidation">
    <div class="header-wrapper " formGroupName="context">
        <div class="header-top border-light-bottom">
            <div class="description">
                <p class="primary-text bold-text content-l">{{alertvarservice.ruleTitles.rule_details}}</p>
                <p class="primary-text content-m pl-3">{{alertvarservice.description.consolidation}}</p>
            </div>
            <div class="details" >
                <div class="context">
                    <div class="rule-name">
                        <p class="primary-text bold-text content-l">{{alertvarservice.ruleTitles.rule_name}}</p>
                        <div class="alertDetails pb-5 pl-3">
                            <p class="content-m primary-text">{{alertvarservice.ruleTitles.auto_rule}} {{alertId}}</p>
                            <input class="input-border primary-bg" formControlName="description" type="text" [placeholder]="alertvarservice.ruleTitles.description">
                            <div class="toggles">
                                <div class="activate-rule">
                                    <p class="primary-text bold-text content-l">{{alertvarservice.ruleTitles.activate_rule}}</p>
                                    <app-toggle-button  formControlName="activate" [leftLabel]="alertvarservice.ruleTitles.no" [rightLabel]="alertvarservice.ruleTitles.yes"></app-toggle-button>
                                </div>
                                <div class="retroactive">                                <p class="primary-text bold-text content-l">{{alertvarservice.ruleTitles.run_retroactively}}</p>
                                    <app-toggle-button formControlName="retroactive"  [leftLabel]="alertvarservice.ruleTitles.no" [rightLabel]="alertvarservice.ruleTitles.yes"></app-toggle-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="body">
        <div class="body-bottom pt-5" formGroupName="conditions">
            <p class=" query-title primary-text primary-bg bold-text content-l px-1">{{alertvarservice.ruleTitles.define_rule_condition}}</p>
            <div class="content-wrapper mt-7 pl-3">
                <div class="fields">
                    <p class="primary-text content-m">Signature Fields :</p>
                    <div class="field-input">
                        <app-overlay-select formControlName="fields" [hasMultiSelect]=true [data]="alertvarservice.consolidationfields">
                        </app-overlay-select>
                        <ng-container *ngIf="fieldError">
                            <p class="alert-text content-s">{{alertvarservice.consolidationError.field_error}}</p>
                        </ng-container>
                    </div>
                    <div class="chips-container">
                        <ng-container *ngFor="let field of fields.value">
                            <div class="tag-chip secondary-text my-2 mr-2 px-4 pt-1 radius-xl border-report">
                                <span class="span-m px-2">{{field}}</span>
                                <img class="pr-1 icon-s enable-action" src="assets/rule/close-dialog.svg" (click)="removeChip(field)">
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="timeframe">
                    <p class="primary-text content-m">Enable Time Frame :</p>
                    <div class="time-input">
                        <app-overlay-select [data]="alertvarservice.consolidationTime" formControlName="timeframe">
                        </app-overlay-select>
                        <ng-container *ngIf="timeError">
                            <p class="alert-text content-s">{{alertvarservice.consolidationError.time_error}}</p>
                        </ng-container>
                    </div>
                </div>
                <div class="runtest">
                    <div class="test pt-5">
                        <p class="selectable-text content-m enable-action" (click)="verifyquery()">{{alertvarservice.ruleTitles.run_tests}}</p>
                        <div *ngIf="alertvarservice.showError" class="alert-text content-s">{{alertvarservice.errorTypes.query_error}}</div>
                    </div>
                    <div class="test-results mt-5">
                        <!-- <ng-container *ngIf="alertvarservice.testResultVolume"> -->
                        <ng-container *ngIf="showTest">
                            <div class="labels">
                                <p class="primary-text content-m">{{alertvarservice.ruleTitles.alert_test_volume}}</p>                
                                <p class="primary-text content-m">{{alertvarservice.ruleTitles.auto_actionable_alerts}}</p>
                                <p class="primary-text content-m">{{alertvarservice.ruleTitles.effective_noise_reduction}}</p>
                            </div>
                            <div class="colon">
                                <p *ngFor="let p of [1,2,3]" class="primary-text content-m">:</p>
                            </div>
                            <div class="results">
                                <p class="selectable-text content-m">{{alertvarservice.testResultVolume}} {{alertsLabel}}</p>
                                <p class="selectable-text content-m">{{testResultActionable}} {{alertsLabel}}</p>
                                <p class="selectable-text content-m">{{testResultNoise}} {{percentLabel}}</p>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer p-3 ">
            <div class="buttons pr-5">
                <button class="submit" (click)="submitClicked()">{{alertvarservice.ruleTitles.save}}</button>
                <button class="cancel" (click)="cancelClick()">{{alertvarservice.ruleTitles.cancel}}</button>
            </div>
        </div>
    </div>
</div>